import domReady from "@wordpress/dom-ready";
import Sidebar from "./view/sidebar";

type Options = {
    rootSelector: string;
    contentSelector: string;
    toggleSelector: string;
    containerSelector: string;
};

const defaultOptions: Options = {
    rootSelector: '.wp-block-singold-sidebar',
    contentSelector: '.is-layout-constrained > *',
    toggleSelector: '.wp-block-singold-sidebar-toggle',
    containerSelector: '.wp-block-singold-sidebar-container',
};

class View {
    constructor(private options: Options = defaultOptions) {
        this.options = {
            ...defaultOptions,
            ...options,
        };

        this.init();
    }

    public init(): void {
        const blocks = document.querySelectorAll(this.options.rootSelector);

        blocks.forEach((el: HTMLElement) => {
            new Sidebar(el, {
                contentSelector: this.options.contentSelector,
                toggleSelector: this.options.toggleSelector,
                containerSelector: this.options.containerSelector,
            });
        });
    }
}

domReady(() => {
    new View();
});
